import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const COPY = {
  en: {
    eyebrow: "Reviews",
    title: "Trusted by riders who expect more",
    reviews: [
      { name: "Ahmed K.", text: "Excellent service, very professional driver and smooth ride." },
      { name: "Sarah M.", text: "Best chauffeur service in Jeddah. Highly recommended!" },
      { name: "Faisal A.", text: "On time, clean car, and very polite driver." },
    ],
  },
  ar: {
    eyebrow: "آراء العملاء",
    title: "موثوق من الركاب الذين يتوقعون الأفضل",
    reviews: [
      { name: "أحمد ك.", text: "خدمة ممتازة وسائق محترف ورحلة سلسة." },
      { name: "سارة م.", text: "أفضل خدمة سائق خاص في جدة. أنصح بها بشدة!" },
      { name: "فيصل أ.", text: "في الموعد، سيارة نظيفة، وسائق مهذب جداً." },
    ],
  },
};

export default function Testimonials() {
  const { lang } = useLanguage();
  const copy = COPY[lang] || COPY.en;

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-20 md:py-24 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-[#C7A239] font-medium mb-4">{copy.eyebrow}</p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight">
            {copy.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {copy.reviews.map((review, index) => (
            <motion.article
              key={review.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="rounded-[28px] border border-white/8 bg-[#111] p-7"
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#C7A239] text-[#C7A239]" />
                ))}
              </div>
              <p className="text-gray-300 leading-relaxed mb-6">“{review.text}”</p>
              <p className="text-white font-medium">{review.name}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
